import { CurveTemperature } from '../util/temperature-curve-utility'

export function calculatePowerCoverageFactor(
  heatPumpTemperature: number,
  heatCircuitTemperature: CurveTemperature,
): number {
  if (heatCircuitTemperature.return > heatPumpTemperature) {
    return 0
  }

  return Math.min(
    1,
    (heatPumpTemperature - heatCircuitTemperature.return) /
      (heatCircuitTemperature.in - heatCircuitTemperature.return),
  )
}
